module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sidebar"
  }, [_c('a', {
    staticClass: "is-hidden-desktop has-text-centered trigger-menu",
    on: {
      "click": function($event) {
        _vm.isHiddenMobile = !_vm.isHiddenMobile
      }
    }
  }, [(_vm.isHiddenMobile) ? _c('p', {
    staticClass: "has-text-primary"
  }, [_vm._m(0), _c('b-icon', {
    attrs: {
      "icon": "keyboard_arrow_down",
      "type": "is-primary",
      "size": "large"
    }
  })], 1) : _vm._e(), (!_vm.isHiddenMobile) ? _c('p', {
    staticClass: "has-text-primary"
  }, [_vm._m(1), _c('b-icon', {
    attrs: {
      "icon": "keyboard_arrow_up",
      "type": "is-primary",
      "size": "large"
    }
  })], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('aside', {
    staticClass: "menu",
    class: {
      'is-hidden-mobile': _vm.isHiddenMobile
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("Geral")]), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "exact": "exact"
    },
    nativeOn: {
      "click": function($event) {
        _vm.isHiddenMobile = true
      }
    }
  }, [_vm._v("Dashboard")])], 1)]), _vm._l((_vm.sections), function(section) {
    return (_vm.checkMainVisibility(section)) ? _c('section', {
      key: section.meta.label,
      staticClass: "menu-section"
    }, [_c('p', {
      staticClass: "menu-label"
    }, [_vm._v(_vm._s(section.meta.label))]), _c('ul', {
      staticClass: "menu-list"
    }, _vm._l((section.children), function(route) {
      return (_vm.checkVisibility(route)) ? _c('div', {
        key: route.name,
        staticClass: "section-menu-item"
      }, [(!route.children) ? _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: route.name
          }
        },
        nativeOn: {
          "click": function($event) {
            _vm.isHiddenMobile = true
          }
        }
      }, [_vm._v(_vm._s(route.meta.label))])], 1) : _vm._e(), (route.children && route.children.length) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            return _vm.toggleChildrenVisibility(route)
          }
        }
      }, [_vm._v(_vm._s(route.meta.label)), (_vm.childrenOpen != route) ? _c('b-icon', {
        staticClass: "is-pulled-right",
        attrs: {
          "icon": "keyboard_arrow_down"
        }
      }) : _vm._e(), (_vm.childrenOpen == route) ? _c('b-icon', {
        staticClass: "is-pulled-right",
        attrs: {
          "icon": "keyboard_arrow_up"
        }
      }) : _vm._e()], 1), (_vm.childrenOpen == route) ? _c('ul', _vm._l((route.children), function(child) {
        return (_vm.checkVisibility(child)) ? _c('li', {
          key: child.name,
          staticClass: "section-menu-item"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: child.name
            },
            "exact": "exact"
          },
          nativeOn: {
            "click": function($event) {
              _vm.isHiddenMobile = true
            }
          }
        }, [_vm._v(_vm._s(child.meta.label))])], 1) : _vm._e()
      }), 0) : _vm._e()]) : _vm._e()]) : _vm._e()
    }), 0)]) : _vm._e()
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_vm._v("Abrir Menu "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_vm._v("Fechar Menu "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f815bafc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 411
// module chunks = 56